export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [// 商品管理-电商商品管理-商品管理列表
  {
    path: 'ecCommodityList',
    name: 'ecCommodityList',
    meta: {
      title: '电商商品管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecCommodityList']
    },
    component: function component() {
      return import('@/pages/commodityModule/ecCommodityMenu/ecCommodityList/ecCommodityList');
    }
  }, // 商品管理-电商商品管理-商品管理列表- 查看商品
  {
    path: 'ecCommodityDetail',
    name: 'ecCommodityDetail',
    meta: {
      title: '电商商品管理',
      cache: true,
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/ecCommodityMenu/ecCommodityList/ecCommodityDetail');
    }
  }, // 商品管理-电商商品管理-商品管理列表- 查看单品
  {
    path: 'ecCommodityItemDetail',
    name: 'ecCommodityItemDetail',
    meta: {
      title: '电商商品管理',
      cache: true,
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/ecCommodityMenu/ecCommodityList/ecCommodityItemDetail');
    }
  }, // 商品管理-电商商品管理-商品加价管理- 商品加价管理列表
  {
    path: 'ecCommodityMarkupList',
    name: 'ecCommodityMarkupList',
    meta: {
      title: '电商商品加价管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecCommodityMarkupList']
    },
    component: function component() {
      return import('@/pages/commodityModule/ecCommodityMenu/ecCommodityMarkupList/ecCommodityMarkupList');
    }
  }, // 商品管理-电商商品管理-商品加价管理- 添加例外单品
  {
    path: 'ecCommodityMarkupItemAdd',
    name: 'ecCommodityMarkupItemAdd',
    meta: {
      title: '电商商品加价管理',
      cache: true,
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/ecCommodityMenu/ecCommodityMarkupList/ecCommodityMarkupItemAdd');
    }
  }, // 商品管理-电商商品管理-商品价格监控列表
  {
    path: 'ecCommodityPriceMonitorList',
    name: 'ecCommodityPriceMonitorList',
    meta: {
      title: '电商商品价格监控',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecCommodityPriceMonitorList']
    },
    component: function component() {
      return import('@/pages/commodityModule/ecCommodityMenu/ecCommodityPriceMonitorList/ecCommodityPriceMonitorList');
    }
  }, // 商品管理-电商商品管理-商品价格监控详情
  {
    path: 'ecCommodityPriceMonitorDetail',
    name: 'ecCommodityPriceMonitorDetail',
    meta: {
      title: '电商商品价格监控',
      cache: true,
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/ecCommodityMenu/ecCommodityPriceMonitorList/ecCommodityPriceMonitorDetail');
    }
  }, // 商品管理-电商商品管理-商品审批管理列表
  {
    path: 'ecCommodityApprovalList',
    name: 'ecCommodityApprovalList',
    meta: {
      title: '电商商品审批管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecCommodityApprovalList']
    },
    component: function component() {
      return import('@/pages/commodityModule/ecCommodityMenu/ecCommodityApprovalList/ecCommodityApprovalList');
    }
  }, // 商品管理-电商商品管理-商品ES数据迁移
  {
    path: 'ecCommodityParticplesManage',
    name: 'ecCommodityParticplesManage',
    meta: {
      title: '商品分词管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['ecCommodityParticplesManage']
    },
    component: function component() {
      return import('@/pages/commodityModule/ecCommodityMenu/ecCommodityParticplesManage/ecCommodityParticplesManage');
    }
  }, // 商品管理-库存管理-协议库存管理列表
  {
    path: 'agrStockList',
    name: 'agrStockList',
    meta: {
      title: '协议库存管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrStockList']
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityStockMenu/agrStockList/agrStockList');
    }
  }, // 商品管理-库存管理-协议库存管理列表
  {
    path: 'unagrStockList',
    name: 'unagrStockList',
    meta: {
      title: '无协议库存管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrStockList']
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityStockMenu/unagrStockList/unagrStockList');
    }
  }, // 商品管理-基础设置-前台商品类目
  {
    path: 'cpCommodityCategory',
    name: 'cpCommodityCategory',
    meta: {
      title: '前台商品类目',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['cpCommodityCategory']
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/cpCommodityCategory/cpCommodityCategory');
    }
  }, // 商品管理-基础设置-前台商品类目
  {
    path: 'cpCommodityCategoryForm',
    name: 'cpCommodityCategoryForm',
    meta: {
      title: '前台商品类目新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/cpCommodityCategory/cpCommodityCategoryForm');
    }
  }, // 商品管理-基础设置-前台商品类目-商品类目维护
  {
    path: 'cpCommodityTypeUphold',
    name: 'cpCommodityTypeUphold',
    meta: {
      title: '前台商品类目类型维护',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/cpCommodityCategory/cpCommodityTypeUphold');
    }
  }, // 商品管理-基础设置-商品类型管理列表
  {
    path: 'commodityTypeList',
    name: 'commodityTypeList',
    meta: {
      title: '商品类型管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['commodityTypeList']
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityTypeList/commodityTypeList');
    }
  }, // 商品管理-基础设置-商品类型管理-商品类型新增
  {
    path: 'commodityTypeForm',
    name: 'commodityTypeForm',
    meta: {
      title: '新增商品类型',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityTypeList/commodityTypeForm');
    }
  }, // 商品管理-基础设置-商品类型管理列表-属性组管理列表
  {
    path: 'cpManageAttrGroup',
    name: 'cpManageAttrGroup',
    meta: {
      title: '属性组管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityTypeList/cpManageAttrGroup');
    }
  }, // 商品管理-基础设置-商品类型管理列表-管理属性组属性
  {
    path: 'cpManageAttrGroupAttr',
    name: 'cpManageAttrGroupAttr',
    meta: {
      title: '属性组属性管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityTypeList/cpManageAttrGroupAttr');
    }
  }, // 商品管理-基础设置-商品类型管理列表-管理属性组属性-关联属性
  {
    path: 'cpRelateAttr',
    name: 'cpRelateAttr',
    meta: {
      title: '属性组属性管理关联属性',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityTypeList/cpRelateAttr');
    }
  }, // 商品管理-基础设置-商品类型管理列表-管理属性组属性-属性参照
  {
    path: 'cpAttrReference',
    name: 'cpAttrReference',
    meta: {
      title: '属性组属性管理属性参照',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityTypeList/cpAttrReference');
    }
  }, // 商品管理-基础设置-商品属性库管理列表
  {
    path: 'attrDatabaseList',
    name: 'attrDatabaseList',
    meta: {
      title: '商品属性库管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['attrDatabaseList']
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/attrDatabaseList/attrDatabaseList');
    }
  }, // 商品管理-基础设置-商品属性值管理列表
  {
    path: 'attrValueManage',
    name: 'attrValueManage',
    meta: {
      title: '电商商品属性值管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/attrDatabaseList/attrValueManage');
    }
  }, // 商品管理-基础设置-商品属性值管理列表
  {
    path: 'standAttrValueManage',
    name: 'standAttrValueManage',
    meta: {
      title: '标准商品属性值管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/attrDatabaseList/standAttrValueManage');
    }
  }, // 商品管理-基础设置-商品池管理列表
  {
    path: 'commodityPollList',
    name: 'commodityPollList',
    meta: {
      title: '商品池管理列表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['commodityPollList']
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityPollList/commodityPollList');
    }
  }, // 商品管理-基础设置-商品池管理列表-维护关联商品
  {
    path: 'upholdRelatedGoods',
    name: 'upholdRelatedGoods',
    meta: {
      title: '维护关联商品',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityPollList/upholdRelatedGoods');
    }
  }, // 商品管理-基础设置-商品池管理列表-维护关联单品
  {
    path: 'upholdRelatedGoodsCopy',
    name: 'upholdRelatedGoodsCopy',
    meta: {
      title: '维护关联单品',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityPollList/upholdRelatedGoodsCopy');
    }
  }, {
    path: 'relatedGoods',
    name: 'relatedGoods',
    meta: {
      title: '关联商品',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityPollList/relatedGoods');
    }
  }, {
    path: 'relatedGoodsCopy',
    name: 'relatedGoodsCopy',
    meta: {
      title: '关联商品',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityPollList/relatedGoodsCopy');
    }
  }, // 商品管理-基础设置-商品池管理列表-维护关联标签
  {
    path: 'upholdRelatedTags',
    name: 'upholdRelatedTags',
    meta: {
      title: '维护关联标签',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityPollList/upholdRelatedTags');
    }
  }, {
    path: 'relatedTags',
    name: 'relatedTags',
    meta: {
      title: '关联标签',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityPollList/relatedTags');
    }
  }, // 商品管理-基础设置-品牌管理
  {
    path: 'brandList',
    name: 'brandList',
    meta: {
      title: '品牌管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['brandList']
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/brandList/brandList');
    }
  }, // 商品管理-基础设置-品牌管理-品牌详情
  {
    path: 'brandDetail',
    name: 'brandDetail',
    meta: {
      title: '品牌详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/brandList/brandDetail');
    }
  }, // 商品管理-基础设置-品牌管理-品牌新增修改
  {
    path: 'brandForm',
    name: 'brandForm',
    meta: {
      title: '新增商城品牌',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/brandList/brandForm');
    }
  }, // 商品管理-基础设置-品牌管理-维护映射关系 - 查看映射
  {
    path: 'mappingDetail',
    name: 'mappingDetail',
    meta: {
      title: '维护映射关系',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/brandList/mappingDetail');
    }
  }, // 商品管理-基础设置-物料维护
  {
    path: 'materielUpholdList',
    name: 'materielUpholdList',
    meta: {
      title: '物料维护',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['materielUpholdList']
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/materielUpholdList/materielUpholdList');
    }
  }, {
    path: 'materielForm',
    name: 'materielForm',
    meta: {
      title: '新增物料信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/materielUpholdList/materielForm');
    }
  }, {
    path: 'materielDetail',
    name: 'materielDetail',
    meta: {
      title: '物料信息详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/materielUpholdList/materielDetail');
    }
  }, // 商品管理-基础设置-物料维分类
  {
    path: 'materielClassList',
    name: 'materielClassList',
    meta: {
      title: '物料分类',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['materielClassList']
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/materielClassList/materielClassList');
    }
  }, // 商品管理-基础设置-频道管理
  {
    path: 'channelManageList',
    name: 'channelManageList',
    meta: {
      title: '频道管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['channelManageList']
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/channelManageList/channelManageList');
    }
  }, // 商品管理-基础设置-频道管理-新增修改
  {
    path: 'channelManageForm',
    name: 'channelManageForm',
    meta: {
      title: '频道管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/channelManageList/channelManageForm');
    }
  }, // 商品管理-基础设置-频道管理-频道商品类目关联管理
  {
    path: 'cpChannelManagementCategory',
    name: 'cpChannelManagementCategory',
    meta: {
      title: '频道商品类目关联管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/channelManageList/cpChannelManagementCategory');
    }
  }, // 商品管理-基础设置-频道管理-频道商品池关联管理
  {
    path: 'cpChanalManagementCommodity',
    name: 'cpChanalManagementCommodity',
    meta: {
      title: '频道商品池关联管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/channelManageList/cpChanalManagementCommodity');
    }
  }, // 商品管理-基础设置-商品分类管理
  {
    path: 'commodityCategoryManage',
    name: 'commodityCategoryManage',
    meta: {
      title: '商品分类管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityCategoryManage/commodityCategoryManage.vue');
    }
  }, // 商品管理-基础设置-商品分类管理-属性管理
  {
    path: 'commodityAttrManage',
    name: 'commodityAttrManage',
    meta: {
      title: '属性管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/commodityCategoryManage/commodityAttrManage.vue');
    }
  }, // 商品管理-协议商品管理-商品管理列表
  {
    path: 'agrCommodityList',
    name: 'agrCommodityList',
    meta: {
      title: '协议商品管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrCommodityList']
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrCommodityList/agrCommodityList');
    }
  }, // 商品管理-协议商品管理-商品详情
  {
    path: 'agrCommodityDetail',
    name: 'agrCommodityDetail',
    meta: {
      title: '协议商品详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrCommodityList/agrCommodityDetail');
    }
  }, // 商品管理-协议商品管理-单品详情
  {
    path: 'agrSkuDetail',
    name: 'agrSkuDetail',
    meta: {
      title: '协议单品详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrCommodityList/agrSkuDetail');
    }
  }, // 商品管理-协议商品管理-商品审批列表
  {
    path: 'agrApprovalList',
    name: 'agrApprovalList',
    meta: {
      title: '协议商品审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrApprovalList']
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrApprovalList/agrApprovalList');
    }
  }, // 商品管理-协议商品管理-商品创建列表
  {
    path: 'agrCreateCommodityList',
    name: 'agrCreateCommodityList',
    meta: {
      title: '协议商品创建列表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrCreateCommodityList']
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrCreateCommodityList/agrCreateCommodityList');
    }
  }, // 商品管理-协议商品管理-商品创建列表
  {
    path: 'agrProductList',
    name: 'agrProductList',
    meta: {
      title: '协议产品列表',
      cache: true
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrCreateCommodityList/agrProductList');
    }
  }, // 商品管理-协议商品管理-商品创建
  {
    path: 'agrCreateCommodity',
    name: 'agrCreateCommodity',
    meta: {
      title: '创建协议商品',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrCreateCommodityList/agrCreateCommodity');
    }
  }, // 商品管理-协议商品管理-商品编辑
  {
    path: 'agrEditCommodity',
    name: 'agrEditCommodity',
    meta: {
      title: '修改协议商品',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrCreateCommodityList/agrEditCommodity');
    }
  }, // 商品管理-协议商品管理-单品编辑
  {
    path: 'agrEditSku',
    name: 'agrEditSku',
    meta: {
      title: '修改单品',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrCommodityList/agrEditSku');
    }
  }, // 商品管理-无协议商品管理-商品创建列表
  {
    path: 'unagrCreateCommodityList',
    name: 'unagrCreateCommodityList',
    meta: {
      title: '无协议商品创建列表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrCreateCommodityList']
    },
    component: function component() {
      return import('@/pages/commodityModule/unagrCommodityMenu/unagrCreateCommodityList/unagrCreateCommodityList');
    }
  }, // 商品管理-无协议商品管理-商品创建
  {
    path: 'unagrCreateCommodity',
    name: 'unagrCreateCommodity',
    meta: {
      title: '无协议商品创建',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/unagrCommodityMenu/unagrCreateCommodityList/unagrCreateCommodity');
    }
  }, // 商品管理-无协议商品管理-商品修改
  {
    path: 'unagrEditCommodity',
    name: 'unagrEditCommodity',
    meta: {
      title: '无协议商品修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/unagrCommodityMenu/unagrCreateCommodityList/unagrEditCommodity');
    }
  }, // 商品管理-无协议商品管理-商品审批列表
  {
    path: 'unagrApprovalList',
    name: 'unagrApprovalList',
    meta: {
      title: '无协议商品审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrApprovalList']
    },
    component: function component() {
      return import('@/pages/commodityModule/unagrCommodityMenu/unagrApprovalList/unagrApprovalList');
    }
  }, // 商品管理-无协议商品管理-商品管理列表
  {
    path: 'unagrCommodityList',
    name: 'unagrCommodityList',
    meta: {
      title: '无协议商品管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unagrCommodityList']
    },
    component: function component() {
      return import('@/pages/commodityModule/unagrCommodityMenu/unagrCommodityList/unagrCommodityList');
    }
  }, // 商品管理-无协议商品管理-单品详情
  {
    path: 'unagrSkuDetail',
    name: 'unagrSkuDetail',
    meta: {
      title: '无协议单品详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/unagrCommodityMenu/unagrCommodityList/unagrSkuDetail');
    }
  }, // 商品管理-无协议商品管理-单品修改
  {
    path: 'unagrEditSku',
    name: 'unagrEditSku',
    meta: {
      title: '修改无协议单品',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/unagrCommodityMenu/unagrCommodityList/unagrEditSku');
    }
  }, // 商品管理-无协议商品管理-商品详情
  {
    path: 'unagrCommodityDetail',
    name: 'unagrCommodityDetail',
    meta: {
      title: '无协议商品详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/unagrCommodityMenu/unagrCommodityList/unagrCommodityDetail');
    }
  }, // 商品管理-基础设置-类目维护管理
  {
    path: 'shopBankNameList',
    name: 'shopBankNameList',
    meta: {
      title: '类目维护管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['shopBankNameList'] // hidden: true

    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/shopBankNameList/shopBankNameList');
    }
  }, // 商品管理-基础设置-类目维护管理-新增/修改类目维护
  {
    path: 'shopBankNameEdit',
    name: 'shopBankNameEdit',
    meta: {
      title: '类目维护管理',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/shopBankNameList/shopBankNameEdit');
    }
  }, // 商品管理-基础设置-类目维护管理-查看类目维护
  {
    path: 'shopBankNameDetail',
    name: 'shopBankNameDetail',
    meta: {
      title: '类目维护管理',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityBaseSettingMenu/shopBankNameList/shopBankNameDetail');
    }
  }, // 批量维护商品图片
  {
    path: 'maintenancePictures',
    name: 'maintenancePictures',
    meta: {
      title: '批量维护商品图片',
      // cache: true
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrCommodityList/maintenancePictures.vue');
    }
  }, // 商城链接
  {
    path: 'priceComparisonList',
    name: 'priceComparisonList',
    meta: {
      title: '商城链接',
      cache: true,
      hidden: false
    },
    component: function component() {
      return import('@/pages/commodityModule/riskControlCenterMenu/priceComparisonList.vue');
    }
  }, // 商品开发经理维护
  {
    path: 'managerMaintenanceList',
    name: 'managerMaintenanceList',
    meta: {
      title: '商品开发经理维护',
      cache: true,
      hidden: false
    },
    component: function component() {
      return import('@/pages/commodityModule/riskControlCenterMenu/managerMaintenanceList.vue');
    }
  }, // 调整价格
  {
    path: 'adjustPrice',
    name: 'adjustPrice',
    meta: {
      title: '价格调整',
      cache: false,
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrApprovalList/adjustPrice.vue');
    }
  }, // 调整价格
  {
    path: 'newAgrCommodityList',
    name: 'newAgrCommodityList',
    meta: {
      title: '商品管理',
      cache: true,
      hidden: false
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrCommodityList/newAgrCommodityList.vue');
    }
  }, // 库存管理
  {
    path: 'newAgrStockList',
    name: 'newAgrStockList',
    meta: {
      title: '库存管理',
      cache: true,
      hidden: false
    },
    component: function component() {
      return import('@/pages/commodityModule/commodityStockMenu/agrStockList/newAgrStockList.vue');
    }
  }, // 批量维护商品描述
  {
    path: 'maintenanceDescrip',
    name: 'maintenanceDescrip',
    meta: {
      title: '批量维护商品描述',
      cache: false,
      hidden: true
    },
    component: function component() {
      return import('@/pages/commodityModule/agrCommodityMenu/agrCommodityList/maintenanceDescrip.vue');
    }
  }, // 商品管理-标准商品管理-标准商品分类管理
  {
    path: 'staCommidityList',
    name: 'staCommidityList',
    meta: {
      title: '标准商品管理'
    },
    component: function component() {
      return import('@/pages/commodityModule/staCommidityMenu/staCommidityList/staCommidityList');
    }
  }, {
    path: 'newStaCommidityList',
    name: 'newStaCommidityList',
    meta: {
      title: '标准商品管理',
      cache: true,
      hidden: false
    },
    component: function component() {
      return import('@/pages/commodityModule/staCommidityMenu/staCommidityList/newStaCommidityList');
    }
  }, // 商品管理-标准商品管理-新建标准商品
  {
    path: 'staSkuAdd',
    name: 'staSkuAdd',
    meta: {
      title: '新建商品'
    },
    component: function component() {
      return import('@/pages/commodityModule/staCommidityMenu/staSkuAdd/staSkuAdd');
    }
  }, // 商品管理-标准商品管理-商品详情
  {
    path: 'skuDetail',
    name: 'skuDetail',
    meta: {
      title: '商品详情'
    },
    component: function component() {
      return import('@/pages/commodityModule/staCommidityMenu/staCommidityList/skuDetail');
    }
  }, // 商品管理-标准商品管理-新建采购信息
  {
    path: 'shopProcurementAdd',
    name: 'shopProcurementAdd',
    meta: {
      title: '新建采购信息'
    },
    component: function component() {
      return import('@/pages/commodityModule/staCommidityMenu/staSkuAdd/shopProcurementAdd');
    }
  }]
};